export default __webpack_public_path__ + "static/media/c002-PPII-3.30499708.svg";